/**
 * UserBriefInfo 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * UserBriefInfo
 */
export interface UserBriefInfo {
  /** 用户ID */
  id?: string
  /** 用户类型 */
  type?: string
  /** 用户名 */
  username?: string
  /** 昵称 */
  nickname?: string
  /** 头像URL */
  avatar_url?: string
  /** 头像缩略图URL */
  avatar_thumb_url?: string
  /** 性别 */
  gender?: string
  /** 段位积分 */
  rank_points?: number
  /** 段位层次 */
  rank_tier?: number
  /** 段位等级 */
  rank_division?: number
  /** 段位星数 */
  rank_stars?: number
  /** 加入的对线队伍阵营 */
  battle_side?: string
}

/**
 * UserBriefInfo Schema
 */
export const UserBriefInfoSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '用户ID',
      format: 'string',
      type: 'string',
      label: '用户ID',
    },
    type: {
      description: '用户类型',
      format: 'cons.UserType',
      type: 'string',
      label: '用户类型',
    },
    username: {
      description: '用户名',
      format: 'string',
      type: 'string',
      label: '用户名',
    },
    nickname: {
      description: '昵称',
      format: 'string',
      type: 'string',
      label: '昵称',
    },
    avatar_url: {
      description: '头像URL',
      format: 'string',
      type: 'string',
      label: '头像URL',
    },
    avatar_thumb_url: {
      description: '头像缩略图URL',
      format: 'string',
      type: 'string',
      label: '头像缩略图URL',
    },
    gender: {
      description: '性别',
      format: 'cons.UserGender',
      type: 'string',
      label: '性别',
    },
    rank_points: {
      description: '段位积分',
      format: 'int',
      type: 'integer',
      label: '段位积分',
    },
    rank_tier: {
      description: '段位层次',
      format: 'cons.UserRankTier',
      type: 'integer',
      label: '段位层次',
    },
    rank_division: {
      description: '段位等级',
      format: 'cons.UserRankDivision',
      type: 'integer',
      label: '段位等级',
    },
    rank_stars: {
      description: '段位星数',
      format: 'int',
      type: 'integer',
      label: '段位星数',
    },
    battle_side: {
      description: '加入的对线队伍阵营',
      format: '*cons.BattleSide',
      type: 'string',
      label: '加入的对线队伍阵营',
    },
  },
  type: 'object',
}
